var _ = require('./lodash.min').runInContext();

module.exports = require('./fp/_baseConvert')(_, _);